import { render, staticRenderFns } from "./TopSellingItems.vue?vue&type=template&id=3874938e"
import script from "./TopSellingItems.vue?vue&type=script&lang=js"
export * from "./TopSellingItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports